import { render, staticRenderFns } from "./ChangeAssignmentTypeSection.vue?vue&type=template&id=e390ad4c&scoped=true&"
import script from "./ChangeAssignmentTypeSection.vue?vue&type=script&lang=js&"
export * from "./ChangeAssignmentTypeSection.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAssignmentTypeSection.vue?vue&type=style&index=0&id=e390ad4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e390ad4c",
  null
  
)

export default component.exports